var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_394_14606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2027 0.500001H0.504386C0.41181 0.499809 0.320979 0.525189 0.241913 0.573343C0.162846 0.621497 0.0986151 0.690553 0.0563047 0.772894C0.0134227 0.856377 -0.00557234 0.950081 0.00141414 1.04367C0.00840062 1.13726 0.0410972 1.22711 0.0958986 1.3033L4.01533 6.82467C4.01664 6.82659 4.01807 6.82836 4.01938 6.83027C4.16181 7.02256 4.23887 7.25543 4.23925 7.49472V11.9962C4.23884 12.0622 4.25147 12.1276 4.27642 12.1887C4.30137 12.2498 4.33814 12.3054 4.38462 12.3522C4.43115 12.399 4.48646 12.4362 4.54738 12.4615C4.6083 12.4869 4.67363 12.5 4.73962 12.5C4.80737 12.4999 4.87444 12.4864 4.93699 12.4604L7.13941 11.6207C7.33668 11.5604 7.46768 11.3742 7.46768 11.15V7.49472C7.46806 7.25546 7.54506 7.0226 7.68739 6.83027C7.6887 6.82836 7.69013 6.82659 7.69144 6.82467L11.611 1.30318C11.6658 1.22704 11.6985 1.13724 11.7055 1.04369C11.7125 0.950142 11.6935 0.856482 11.6506 0.773047C11.6083 0.690677 11.5441 0.621586 11.4651 0.573403C11.3861 0.525219 11.2952 0.499817 11.2027 0.500001Z",
    fill: "#555555"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_394_14606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.226cd829932c90b63af55dfae5619d34.svg";
export { ForwardRef as ReactComponent };